import {
  CREATE_SUBCATEGORY_FAILURE,
  CREATE_SUBCATEGORY_REQUEST,
  GET_ALL_SUBCATEGORY_REQUEST,
  GET_ALL_SUBCATEGORY_SUCCESS,
  GET_ALL_SUBCATEGORY_FAILURE,
  DELETE_SUBCATEGORY_REQUEST,
  DELETE_SUBCATEGORY_FAILURE,
  UPDATE_SUBCATEGORY_REQUEST,
  UPDATE_SUBCATEGORY_FAILURE,
} from "./ActionType";

const initialState = {
  subCategories: [],
  loading: false,
  error: "",
};

export const adminSubCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };

    case CREATE_SUBCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SUBCATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", subCategories: action.payload };

    case GET_ALL_SUBCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };

    case DELETE_SUBCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };

    case UPDATE_SUBCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
